import { useAppServices } from "hook/services";
import React, { useState } from "react";
import { useEffect } from "react";

function RemoveAccessModal({ open }) {
  const Service = useAppServices();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [removeAccess, setRemoveAccess] = useState({
    heading: "Your Access to SmartDirectoryAI is Currently Restricted.",
    text: 'Please contact support to restore your access. <a href="https://offlinesharks.com/support">https://offlinesharks.com/support</a>',
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const fetchRemoveAccessSettings = async () => {
      try {
        setLoading(true);
        const { response } = await Service.superadmin.GET();
        if (response?.success && response?.data?.remove_access) {
          setRemoveAccess((prev) => ({
            heading: response.data.remove_access.heading || prev.heading,
            text: response.data.remove_access.text || prev.text,
          }));
        }
      } catch (error) {
        console.error("Failed to load remove access settings", error);
      } finally {
        setLoading(false);
      }
    };

    if (open) fetchRemoveAccessSettings();
  }, [open]);

  // Responsive modal width
  const getModalWidth = () => {
    if (windowWidth <= 480) return '95vw';
    if (windowWidth <= 768) return '90vw';
    if (windowWidth <= 1024) return '70vw';
    return '50vw';
  };
  

  const headerStyle = {
    padding: "20px 30px",
    borderBottom: "1px solid #eee",
    backgroundColor: "#f7f7f7",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  };

  const contentStyle = {
    padding: "30px",
    fontSize: "14px",
    color: "#333",
    lineHeight: 1.7,
    backgroundColor: "#fff",
    textAlign: "center",
    '@media (max-width: 768px)': {
      padding: "20px 15px",
    },
  };

  // Responsive modal container
  const modalContainerStyle = {
    width: getModalWidth(),
    maxHeight: windowWidth <= 768 ? '80vh' : '50vh',
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    overflowY: "auto",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
    zIndex: 1050,
  };

  // Responsive heading styles
  const headingStyle = {
    fontSize: "22px",
    fontWeight: "700",
    margin: 0,
    '@media (max-width: 768px)': {
      fontSize: "18px",
    },
  };

  const mainHeadingStyle = {
    fontSize: "22px",
    fontWeight: "700",
    marginBottom: "20px",
    '@media (max-width: 768px)': {
      fontSize: "18px",
      marginBottom: "15px",
    },
  };

  // Convert style objects to actual CSS with media queries
  const getStyles = (styleObj) => {
    const base = { ...styleObj };
    delete base['@media'];
    return base;
  };

  const getMediaQueries = (styleObj) => {
    const mediaQueries = {};
    for (const key in styleObj) {
      if (key.startsWith('@media')) {
        mediaQueries[key] = styleObj[key];
      }
    }
    return mediaQueries;
  };

  const handleBodyClick = (event) => {
    const anchor = event.target.closest("a");
    if (anchor?.href) {
      event.preventDefault();
      window.open(anchor.href, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <>
      {open && (
        <>
          <div className="modal-zz-confirm">
            <div 
              style={getStyles(modalContainerStyle)}
              css={getMediaQueries(modalContainerStyle)}
            >
              <div style={headerStyle}>
                <h2 style={getStyles(headingStyle)} css={getMediaQueries(headingStyle)}>
                  Access Removed
                </h2>
              </div>
              <div style={getStyles(contentStyle)} css={getMediaQueries(contentStyle)}>
                <h1 style={getStyles(mainHeadingStyle)} css={getMediaQueries(mainHeadingStyle)}>
                  {removeAccess.heading}
                </h1>
                {loading ? (
                  <p>Loading...</p>
                ) : (
                  <div
                    onClick={handleBodyClick}
                    dangerouslySetInnerHTML={{ __html: removeAccess.text }}
                  />
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default RemoveAccessModal;
